/// <amd-module name="Release/Landing/LeftPanel/PipelinesActionCreator" />
import { IVssPageContext } from "VSS/Platform/Context";

import { ActionCreatorBase } from "DistributedTask/Flux/Actions";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { PipelinesActions } from "./PipelinesActions";
import { SelectionActions, IDefinitionSelectionPayload } from "Selection/SelectionActions";
import { IReleaseHubServiceDataService } from "PageData";

export class PipelinesActionCreator extends ActionCreatorBase {
    public static getKey(): string {
        return "release-landing-general-pipelines-actioncreator";
    }

    public initialize(): void {
        this._actions = ActionsHubManager.GetActionsHub<PipelinesActions>(PipelinesActions);
        this._selectionActions = ActionsHubManager.GetActionsHub<SelectionActions>(SelectionActions);
    }

    public removePipeline(definitionId: number, definitionPath: string): void {
        this._actions.removePipeline.invoke({ pipelineId: definitionId, pipelinePath: definitionPath });
        this._selectionActions.selectDefinition.invoke({
            id: -1,
            noSelection: true
        } as IDefinitionSelectionPayload);
    }

    public handleUndeletePipeline(pageContext: IVssPageContext): void {
        const rmDataService = pageContext.getService<IReleaseHubServiceDataService>("IReleaseHubServiceDataService");
        rmDataService.clearActiveTabDefinitions();
        this._actions.clearData.invoke(void (0));
    }

    private _actions: PipelinesActions;
    private _selectionActions: SelectionActions;
}
